<template>
    <div>
        <myPage>
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5">
                    <el-input size="small" v-model="search.mod_cname">
                        <span slot="prepend">{{$t('cname')}}{{$t('x_yd')}}</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table class="el-table--border" :data="listData" style="width: 100%" height="100%">
                    <el-table-column prop="mod_cname" :label="listHeader.mod_cname" width="120px"></el-table-column>
                    <el-table-column prop="add_time" :label="listHeader.add_time" width="150px"></el-table-column>
                    <el-table-column :label="$t('set_dep')" width="160px">
                        <template slot-scope="scope">
                            <div class="flex-box pd-5 bg-f8 border-bottom-line" v-for="(item2, index2) in scope.row.mod_deps" :key="'dep'+item2.mod_dep_id">
                                <span class="flex-box-bd tleft">{{item2.cat_cname}}</span>
                                <span class="mg-left5">
                                    <a class="f-red" @click="delModDep(item2.mod_dep_id)"><Icon size="18" type="md-backspace" /></a>
                                </span>
                            </div>
                            <span class="f-blue hand" @click="openModDep(scope.row.mod_id, scope.row.mod_cname)">{{$t('add_dep')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('set_role')" width="220px">
                        <template slot-scope="scope">
                            <div class="flex-box pd-5 bg-f8 border-bottom-line" v-for="(item2, index2) in scope.row.mod_roles" :key="'role'+item2.mod_role_id">
                                <span class="flex-box-bd tleft">{{item2.cat_cname}}</span>
                                <span class="mg-left5">
                                    <span class="f-blue hand" @click="openModRoleFunc(item2, scope.row.mod_cname)">{{$t('set_func')}}</span>
                                    <a class="f-red" @click="delModRole(item2.mod_role_id)"><Icon size="18" type="md-backspace" /></a>
                                </span>
                            </div>
                            <span class="f-blue hand" @click="openModRole(scope.row.mod_id, scope.row.mod_cname)">{{$t('add_role')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" :label="$t('op')" min-width="60px">
                        <template slot-scope="scope">
                            <a class="link" @click="openUpd(scope.row)">{{$t('info')}}</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myPager from '../../components/myPager'
    import myDropdown from '../../components/myDropdown'
    import myDatePicker from '../../components/myDatePicker'
    export default {
        name:"system-mod",
        components:{
            myPager,
            myDropdown,
            myDatePicker
        },
        data:function(){
            const listHeader = {
                mod_cname: this.$t('cname'),
                add_time: this.$t('add_time')
            };
            return{
                self:this,
                show_subview:false,
                relist:false,
                search:{
                    search_url: "mod/list",
                    datearea_id:0,//如果大于0 mounted 要删除date_fr date_to
                    mod_cname: "",
                    date_fr: '',
                    date_to: '',
                    org_level:"",
                    page: 1,
                    limit: 20,
                    pageSize: 0
                },
                listHeader,//表结构
                listData: [],
                excelData: [],
                exportHeader : this.$base.changeJsonKeyValue(listHeader),
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.$base.listPageInit(this,()=>{
                this.list();
            });
        },
        methods:{
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onSearchTextChange: function(data){
                this.list();
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            list: function (change_page) {
                this.$base.list(this, change_page);
            },
            openUpd:function (item) {
                this.$base.linkTo("/system/mod/save",{op: 'upd', item: JSON.stringify(item)});
            },
            openModRole: function (id, mod_cname) {
                this.$base.linkTo("/system/mod/selectRole",{id, mod_cname});
            },
            openModRoleFunc: function (item, mod_cname) {
                var data = {
                    role_cname: item.cat_cname,
                    mod_role_id: item.mod_role_id,
                    mod_id: item.mod_id,
                    mod_cname,
                };
                this.$base.linkTo("/system/mod/roleFunc", {data: JSON.stringify(data)});
            },
            delModRole: function (mod_role_id) {
                let content = this.$t('chk_del_role');
                this.$base.confirm(content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost('mod/del-role',{mod_role_id},(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.$base.msgSuccess(error.errmsg);
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);
                        }
                    });
                });
            },
            openModDep: function (id, mod_cname) {
                this.$base.linkTo("/system/mod/selectDep",{id, mod_cname});
            },
            delModDep: function (mod_dep_id) {
                let content = this.$t('chk_del_dep');
                this.$base.confirm(content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost('mod/del-dep',{mod_dep_id},(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.$base.msgSuccess(error.errmsg);
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);
                        }
                    });
                });
            },
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/mod.vue